import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetPrasad, fetchDonors } from "../../redux/donorSlice";
import ResetPrasadDialog from "./ResetPrasadDialogBox";
import { Button, Snackbar, Alert } from "@mui/material";
import { logger } from "../../utils/logger";

const ResetPrasadSection = (username, role) => {
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

    const handleDialogOpen = () => {
    setDialogOpen(true);
    logger.info("Reset Prasad dialog opened", { username, role });
  };

    const handleDialogClose = () => {
    setDialogOpen(false);
    logger.info("Reset Prasad dialog closed without reset", { username, role });
  };

  const handleReset = async () => {
    setDialogOpen(false);
    const result = await dispatch(resetPrasad());

    if (resetPrasad.fulfilled.match(result)) {
      const count = result.payload?.modifiedCount || 0;

      if (count === 0) {
        logger.info("Reset Prasad executed - no records found", {
          username: username,
          role: role,
        });
        setSnackbar({
          open: true,
          message: "No records found with Prasad = 'Yes'.",
          severity: "info",
        });
      } else {
        logger.info("Reset Prasad successful", {
          modifiedCount: count,
          username: username,
          role: role,
        });
        setSnackbar({
          open: true,
          message: `Reset successful! ${count} donor(s) updated.`,
          severity: "success",
        });
      }
    } else {
      logger.error("Reset Prasad failed", {
        error: result.payload || "Unknown error",
        username: username,
        role: role,
      });
      setSnackbar({
        open: true,
        message: result.payload || "Reset failed.",
        severity: "error",
      });
    }

    dispatch(fetchDonors());
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleDialogOpen}
      >
        Reset Prasad
      </Button>
      <ResetPrasadDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleReset}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ResetPrasadSection;
